/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SocialLinkRow_viewer = {
    readonly isDownloadAppEnabled: boolean | null;
    readonly " $refType": "SocialLinkRow_viewer";
};
export type SocialLinkRow_viewer$data = SocialLinkRow_viewer;
export type SocialLinkRow_viewer$key = {
    readonly " $data"?: SocialLinkRow_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SocialLinkRow_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SocialLinkRow_viewer",
  "selections": [
    {
      "alias": "isDownloadAppEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "DOWNLOAD_APP"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"DOWNLOAD_APP\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '16814f30880528c32ed2f14cff2133fe';
export default node;
